import { Exercise, Lecture, Section, StaffExercise, Tutorial } from "Utils/TutorialConfigHelper";
import timestamps from './level26.json';
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";

const zero = '0:0';

const Level26 = Tutorial(26, zero, [
  Section([
    Lecture('Unit 1 Recap', zero),
    Lecture('Removing Finger Numbers', zero)
  ]),
  Section([
    Exercise('Playing in 4/4', zero, StaffExercise({ objectives: [{}, {}] }), []),
    Exercise('Playing in 3/4', zero, StaffExercise({ objectives: [{}, {}] }), []),
    Exercise('Playing in 2/4', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ])
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level26);
